import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CropVarietiesByCropIdState } from 'src/app/shared/models';

import { adapter } from '../reducers/crop-variety.reducer';

export const getCropVarietiesByCropIdState = createFeatureSelector<CropVarietiesByCropIdState>(
  'crop-varieties-by-crop-id',
);

const { selectAll } = adapter.getSelectors();

export const getCropVarietiesByCropId = createSelector(getCropVarietiesByCropIdState, selectAll);
